import React from 'react';
import './App.css';
import { Switch, Route } from 'react-router-dom';
import MenuFridge from '../containers/MenuFridge';
import ShoppingCart from '../containers/ShoppingCart';
import Checkout from '../containers/Checkout';
import GuardedRoute from '../../preorder/containers/GuardedRoute';
import useAuth from '../../preorder/hooks/useAuth';
import MenuReceipt from '../containers/Receipt';
import MenuAd from '../containers/MenuAd';
import MenuCampaigns from '../containers/MenuCampaigns';
import MenuFlashSale from '../containers/MenuFlashSale';

export default function App() {
  const [checkAuthenticated] = useAuth();

  return (
    <Switch>
      <Route path="/menu/checkout/receipt" component={MenuReceipt} />
      <GuardedRoute
        path="/menu/checkout"
        checkAuthenticated={checkAuthenticated}
        redirectPath="/register"
        component={Checkout}
      />
      <GuardedRoute
        path="/menu/shopping-cart"
        checkAuthenticated={checkAuthenticated}
        redirectPath="/register"
        component={ShoppingCart}
      />
      <Route path="/menu/ad/flash_sale/:fridgeId" component={MenuFlashSale} />
      <Route path="/menu/campaigns/:fridgeId" component={MenuCampaigns} />
      <Route path="/menu/ad/:id" component={MenuAd} />
      <Route path="/menu/:fridgeId?" component={MenuFridge} />
    </Switch>
  );
}
